<template>
  <div class="container">
    <HeadingOne class="-margin-md">ご契約手続きの完了</HeadingOne>

    <NoticeBox class="-success -margin-md">
      <NoticeHeader>
        <h2 class="heading">ご契約が成立いたしました。</h2>
      </NoticeHeader>

      <NoticeBox class="-bgwhite">
        <NoticeBody class="_mb-md-30 _mb-sm-25"
          >ご契約内容のご案内はこちらからご確認ください。</NoticeBody
        >
        <ListGroup class="-link">
          <ListItem href="#" class="-link" @click.prevent="showPdf()">
            <ElementBox>
              <HeadingIcon class="-left _mb-0">
                ご契約内容のご案内<IconBox
                  src="pdf"
                  class="-xs _ml-5"
                ></IconBox>
              </HeadingIcon>
            </ElementBox>
          </ListItem>
        </ListGroup>
      </NoticeBox>
    </NoticeBox>

    <p class="txt02">
      以下より会員さま専用サイトへアクセスしお取引ください。<br />
      今後ともau PAY
      スマートローンをお引き立てのほどよろしくお願い申しあげます。
    </p>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal" router-name="mb001">
        お借り入れはこちら
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import {
  getUserSessionLambdaInvoke,
  apiGetContractPdf,
} from "@/utils/LambdaHelper";
import HeadingOne from "@/components/heading/HeadingOne";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import ElementBox from "@/components/elements/ElementBox";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";
import NoticeBody from "@/components/box/NoticeBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";

export default {
  name: "En013",
  components: {
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    NoticeBody,
    IconBox,
    HeadingIcon,
    ElementBox,
    NoticeHeader,
    NoticeBox,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ご契約締結の完了",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果,契約",
    });
  },
  data() {
    return {
      userSessionData: {
        user_session: "",
        state: "",
      },
    };
  },
  mounted() {
    getUserSessionLambdaInvoke()
      .then((res) => {
        for (let key in res) {
          if (Object.prototype.hasOwnProperty.call(this.userSessionData, key)) {
            this.userSessionData[key] = res[key];
          }
        }
      })
      .catch((error) => {
        goToErrorPage(error);
      });
  },
  methods: {
    showPdf() {
      const userSession = this.userSessionData.user_session;
      const state = this.userSessionData.state;

      apiGetContractPdf({ user_session: userSession, state: state })
        .then(() => {
          if (window.navigator.msSaveBlob) {
            // IEやEdgeの場合、Blob URL Schemeへと変換しなくともダウンロードできる
            window.open(
              `${process.env.VUE_APP_GET_CONTRACT_PDF}?user_session=${userSession}&state=${state}`,
              "_blank"
            );
          } else {
            // BlobをBlob URL Schemeへ変換してリンクタグへ埋め込む
            window.open(
              `${process.env.VUE_APP_GET_CONTRACT_PDF}?user_session=${userSession}&state=${state}`,
              "_blank"
            );
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.txt02 {
  @include mq-up(md) {
    text-align: center;
  }
}

.no-pdf {
  color: red;
}
</style>
